module.exports = __webpack_public_path__ + "media/images/header-graphic-3c570758.svg";